const makeInitialState = cfdiUsage => ({
  cfdiUsage: cfdiUsage || ''
});

export default makeInitialState;
